import React from "react";
import { Conversation } from "../types/queries";
import { useAppSelector } from "../../../app/hooks";
import { ParticipantType } from "../types/common";
import { isSystemMessage } from "../helpers";
import InboxRowListItem from "./InboxRowListItem";
import InboxRowAvatar from "./InboxRowAvatar";
import InboxRowListItemTexts from "./InboxRowListItemTexts";

type Props = {
  conversation: Conversation;
  onConversationChange: (conversation: Conversation) => void;
};

const InboxRow = ({ conversation, onConversationChange }: Props) => {
  const { user } = useAppSelector((state) => state.user);

  const hasMultipleParticipants = conversation.participants.length > 2;
  const singleOtherParticipant = !hasMultipleParticipants
    ? conversation.participants.find(
        (participant) => participant.id !== user?.id,
      )
    : null;
  const isTalentConversation = conversation.participants.some(
    (participant) => participant.type === ParticipantType.TALENT,
  );

  const allOtherParticipants = conversation.participants.filter(
    (participant) => participant.id !== user?.id,
  );

  const supportMessageSenderParticipant = allOtherParticipants.find(
    (participant) =>
      participant.type === ParticipantType.TALENT ||
      participant.type === ParticipantType.CUSTOMER,
  );

  const isSystemMessageType = isSystemMessage(conversation.initiator);

  return (
    <InboxRowListItem
      conversation={conversation}
      onChange={onConversationChange}
    >
      <InboxRowAvatar
        hasMultipleParticipants={hasMultipleParticipants}
        singleOtherParticipant={singleOtherParticipant}
        supportMessageSenderParticipant={supportMessageSenderParticipant}
        isSystemMessageType={isSystemMessageType}
        isTalentConversation={isTalentConversation}
      />
      <InboxRowListItemTexts
        conversation={conversation}
        hasMultipleParticipants={hasMultipleParticipants}
        isTalentConversation={isTalentConversation}
        singleOtherParticipant={singleOtherParticipant}
        supportMessageSenderParticipant={supportMessageSenderParticipant}
      />
    </InboxRowListItem>
  );
};

export default InboxRow;
